import { IsEmail, IsString, MinLength } from 'class-validator';
import { SignupInterface } from '../../interface/auth/signup.interface';
import { MatchString } from '../decorators/match-string.decorator';

export class SignupDto implements SignupInterface {

  @IsEmail({}, { message: 'Email must be valid' })
  email!: string;

  @IsString()
  @MinLength(8, { message: 'Password must be at least 8 characters' })
  password!: string;

  @IsString()
  @MatchString('password', { message: 'Passwords do not match' })
  confirm_password!: string;

  @IsString()
  redirectUrl!: string;
}